var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoads({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 1H1V10.3889H11.8333V1Z",
    stroke: "#44585F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 4.61111H14.7219L16.8886 6.77778V10.3889H11.833V4.61111Z",
    stroke: "#44585F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24989 14C5.24707 14 6.05545 13.1916 6.05545 12.1945C6.05545 11.1973 5.24707 10.3889 4.24989 10.3889C3.25271 10.3889 2.44434 11.1973 2.44434 12.1945C2.44434 13.1916 3.25271 14 4.24989 14Z",
    stroke: "#44585F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6386 14C14.6357 14 15.4441 13.1916 15.4441 12.1945C15.4441 11.1973 14.6357 10.3889 13.6386 10.3889C12.6414 10.3889 11.833 11.1973 11.833 12.1945C11.833 13.1916 12.6414 14 13.6386 14Z",
    stroke: "#44585F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoads);
export default __webpack_public_path__ + "static/media/loads.7fcef494d7dd37cd2e00e392cbb56b26.svg";
export { ForwardRef as ReactComponent };